export default {
      id: "ar_plan-usage",
      viewBox: "0 0 110 100",
      url: "../dist/images/" + "sprite.svg#ar_plan-usage",
      toString: function () {
        return this.url;
      }
    }